import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ICategoryResponse } from './types';

export const getCategories = async (menuId: string): Promise<ICategoryResponse[]> => {
  const res = await fetch(`${API_URL}/menus/${menuId}/sections`);
  if (res.status !== Status.SUCCESS) {
    throw new Error('Unable to fetch categories');
  }
  const json = await res.json();

  return json.data;
};
